module.exports = __webpack_public_path__ + "static/img/icon.339ee0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zhangmen/icon.png
// module id = 9WVk
// module chunks = 5